import React, {useState} from 'react';
import {Document, Page, pdfjs} from 'react-pdf'

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

const PDFViewer = ({ file }) => {
    const [numPages, setNumPages] = useState(null)

    const onDocumentLoadSuccess = ({ numPages }) => {
        setNumPages(numPages);
    }

    return (
        <div>
            {file ? (
                <Document 
                file={file} 
                onLoadSuccess={onDocumentLoadSuccess} 
                onLoadError={(err) => console.error(err)}>
                    {Array.from(new Array(numPages),(_,index) => (
                        <Page key={`page_${index + 1}`} pageNumber={index+1}></Page>
                    ))}
                </Document>
            ):(
                <p>No hay archivo para visualizar</p>
            )}
        </div>

    )
}

export default PDFViewer;